import '../static/major/scss/cms-pages.scss';
import './react-components/price-table.jsx';
import ReactDOM from "react-dom";
import React from "react";
import PriceTableComponent from "./react-components/price-table.jsx";
import './react-components/customer-rating.jsx';
import './react-components/customer-rating-bar.jsx';

function setupShopOnlineStickyComponent() {
  const element = $('#shop-online-sticky');

  if (element !== null && element.length) {
    const position = element.position();

    // Make the #shop-online-sticky box sticky once the user scrolls past it
    window.addEventListener('scroll', () => {
      const height = $(window).scrollTop()
      if (height > position.top) {
        element.addClass('affix');
      } else {
        element.removeClass('affix');
      }
    });
  }
}

function setupPricingTable() {

  const element = document.getElementById('price-table');
  if (element) {
    ReactDOM.render(<PriceTableComponent slug={element.dataset.productSlug}
                                         productType={element.dataset.productType}
                                         components={JSON.parse(element.dataset.components)}/>, element);
  }
}

document.addEventListener('DOMContentLoaded', function () {

  setupPricingTable();
  setupShopOnlineStickyComponent();

});
